import type { Item } from '@/lib/api/types/items';
import {
  useEstimationsQuery,
  useGetEstimationSchemeQuery,
} from '@/lib/queries/common/useGetEstimationScheme';
import { useItemFetchQuery } from '@/lib/queries/common/useGetItemFetchQuery';
import { useItemTypesQuery } from '@/lib/queries/common/useItemTypesQuery';
import { useGetTeamsQuery } from '@/lib/queries/teams/useGetTeamsQuery';
import { useGetItemStatusesQuery } from './useGetItemStatusesQuery';

const PANEL_QUERY_OPTIONS = {
  refetchOnMount: false,
} as const;

export const useItemPanelQuery = (item: Item, enabled = true) => {
  const { data: itemStatuses = [] } = useGetItemStatusesQuery({
    ...PANEL_QUERY_OPTIONS,
    enabled,
  });
  const { data: itemTypes = [] } = useItemTypesQuery({ ...PANEL_QUERY_OPTIONS, enabled });
  const { data: teamsResponse } = useGetTeamsQuery({ ...PANEL_QUERY_OPTIONS, enabled });

  const { data: estimations = [] } = useEstimationsQuery({ enabled });

  const itemEstimation = item.estimationId
    ? estimations.find((estimation) => estimation.id === item.estimationId)
    : undefined;

  const { data: estimationScheme } = useGetEstimationSchemeQuery({
    schemeId: itemEstimation?.estimationSchemeId ?? 0,
  });

  const teams = teamsResponse?.data ?? [];
  const parentItem = useItemFetchQuery({
    itemId: item.parentId ?? 0,
    enabled: enabled && item.parentId != null,
  }).data;

  return {
    itemStatuses,
    itemTypes,
    teams,
    parentItem,
    estimationScheme,
    estimations,
  };
};
